import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { PageWithNavigationComponent } from '../../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-help',
  imports: [PageWithNavigationComponent, MatExpansionModule, MatIconModule],
  templateUrl: './help.component.html',
  styles: `
    .support-panel {
      display: inline-block;
      max-width: 100%;
    }

    .support-panel mat-expansion-panel {
      display: inline-block;
      max-width: 100%;
    }

    .support-panel-header-content {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 700;
    }
  `,
})
export class HelpComponent implements OnInit, OnDestroy {
  private readonly zohoWidgetScriptId: string = 'zoho-feedback-widget-script';
  private readonly zohoWidgetContainerId: string = 'zsfeedbackwidgetdiv';
  private readonly zohoWidgetScriptUrl: string =
    'https://desk.zoho.eu/portal/api/feedbackwidget/244177000000372004?orgId=20114857040&displayType=embeded';

  protected readonly knowledgeBaseUrl: string = 'https://mycableengineering.com/category/mycableengineering-docs/';
  protected readonly fqaUrl = 'https://mycableengineering.com/mycableengineering-software-faq/';
  protected readonly supportFormExpanded = signal(false);

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.ensureZohoWidgetLoaded();
  }

  ngOnDestroy(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.removeZohoWidget();
  }

  private ensureZohoWidgetLoaded(): void {
    const widgetContainer = document.getElementById(this.zohoWidgetContainerId);
    widgetContainer?.replaceChildren();

    if (document.getElementById(this.zohoWidgetScriptId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = this.zohoWidgetScriptId;
    script.type = 'text/javascript';
    script.src = this.zohoWidgetScriptUrl;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  private removeZohoWidget(): void {
    document.getElementById(this.zohoWidgetScriptId)?.remove();
    document.getElementById(this.zohoWidgetContainerId)?.replaceChildren();
  }
}
